module.exports = __webpack_public_path__ + "static/media/firefox-logo.c8eb685c.png";